/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DocumentRedactionActivateRequest = {
    mask_size: DocumentRedactionActivateRequest.mask_size;
};

export namespace DocumentRedactionActivateRequest {

    export enum mask_size {
        SHORT = 'short',
        MEDIUM = 'medium',
        LONG = 'long',
    }


}

